import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import FormBOQTemplate from "../template/BOQ-template-form.xlsx";
import { uploadBOQ } from "../pages/Service";
import { signOut } from "../utils/signOut";
import LogoIndustrial from "../img/logo/WHA-Logo-Industrial.png";
import LogoGroup from "../img/logo/WHA-Logo-Group.png";
import LogoLogistics from "../img/logo/WHA-Logo-Logistics.png";
import LogoUtility from "../img/logo/WHA-Logo-Utilities.png";

// ------------------ exceljs library: Export with template file (style included) ----------------------------------
export async function exportFormBOQ(aiData, userID, uName, inputData) {
  // Sum total for main job & sum sub material and labour for detail job
  const sumBySeq = aiData.reduce((acc, curr) => {
    const seq = Math.floor(curr.seq); // Grouping by the integer part of seq
    const existing = acc.find((item) => item.seq === seq);

    if (existing) {
      existing.total += curr.total; // Add to existing total
      existing.mat_total += curr.mat_total;
      existing.lab_total += curr.lab_total;
    } else {
      acc.push({
        seq,
        total: curr.total,
        mat_total: curr.mat_total !== null ? curr.mat_total : 0,
        lab_total: curr.lab_total !== null ? curr.lab_total : 0,
      }); // Create new entry
    }
    return acc;
  }, []);

  let excelData = [...aiData];

  // Get max seq.
  const maxSeq = Math.floor(sumBySeq[sumBySeq.length - 1].seq);

  // Load the Excel template
  const wb = new ExcelJS.Workbook();

  // Load your template file
  // const templateUrl = BoqTemplate;
  const templateUrl = FormBOQTemplate;
  const response = await fetch(templateUrl);
  const data = await response.arrayBuffer();

  await wb.xlsx.load(data);

  // Access the first worksheet
  const ws = wb.worksheets[0];

  // Write input data to header (project, client, work title)
  ws.getCell(3, 3).value = `LOCATION: ${inputData.project}`;
  ws.getCell(4, 3).value = `CLIENT: ${inputData.client}`;
  ws.getCell(5, 3).value = `WORK TITLE: ${inputData.title}`;
  ws.getCell(6, 3).value = `VENDOR NAME:`;

  // Set logo
  const logo = getLogo(inputData.logo);
  if (logo) {
    const resImg = await fetch(logo);
    const imageBuffer = await resImg.arrayBuffer();
    const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
    ws.addImage(imageId, {
      tl: { col: 1.9, row: 0 },
      ext: { width: 140, height: 120 },
      editAs: "oneCell",
    });
  }

  //Convert data string to int
  for (let i = 0; i < excelData.length; i++) {
    if (excelData[i].total !== "" && excelData[i].total !== null)
      excelData[i].total = parseFloat(excelData[i].total);
    else excelData[i].total = null;
  }

  // Summary last row
  var total = sumBySeq
    .map((row) => row.total)
    .reduce((acc, amount) => acc + amount);
  const profit = total * 0.1;
  const totalBeforeVat = total + profit;
  const vat = totalBeforeVat * 0.07;
  const totalAfterVat = totalBeforeVat + vat;
  const sumData = [
    {
      seq: null,
      // item: `Total of item 1-${itemNum}`,
      item: `Total of item 1-${maxSeq}`,
      brand: "",
      model: "",
      uom: "",
      qty: null,
      mat_cost: null,
      mat_total: null,
      lab_cost: null,
      lab_total: null,
      unit_cost: null,
      total: total,
    },
    {
      seq: null,
      // item: "Overhead and Profit(ไม่เกิน 10% ของยอดรวม)",
      item: "OH and Profit",
      brand: "",
      model: "",
      uom: "",
      qty: null,
      mat_cost: null,
      mat_total: null,
      lab_cost: null,
      lab_total: null,
      unit_cost: null,
      total: profit,
    },
    {
      seq: null,
      item: "Total before Vat",
      brand: "",
      model: "",
      uom: "",
      qty: null,
      mat_cost: null,
      mat_total: null,
      lab_cost: null,
      lab_total: null,
      unit_cost: null,
      total: totalBeforeVat,
    },
    {
      seq: null,
      // item: "Vat(7%)",
      item: "Vat",
      brand: "",
      model: "",
      uom: "",
      qty: null,
      mat_cost: null,
      mat_total: null,
      lab_cost: null,
      lab_total: null,
      unit_cost: null,
      total: "7%",
    },
    {
      seq: null,
      item: "Grand total",
      brand: "",
      model: "",
      uom: "",
      qty: null,
      mat_cost: null,
      mat_total: null,
      lab_cost: null,
      lab_total: null,
      unit_cost: null,
      total: totalAfterVat,
    },
  ];
  excelData.push(...sumData);

  // Write data to specific cells
  const startRow = 9;
  excelData.forEach((row, index) => {
    ws.getRow(startRow + index).values = [
      row.seq,
      row.item,
      row.brand,
      row.model,
      row.uom,
      row.qty,
      row.mat_cost,
      row.mat_total,
      // row.lab_cost,
      // row.lab_total,
      row.lab_cost !== null ? row.lab_cost : row.mat_lab_cost,
      row.lab_total !== null ? row.lab_total : row.mat_lab_total,
      row.unit_cost,
      row.total,
    ];

    if (row.qty === null && row.seq === null) {
      if (ws.getCell(startRow + index, 2).value.includes("Sub Total Item")) {
        for (let col = 1; col <= 12; col++) {
          const cell = ws.getCell(startRow + index, col);
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9E1F2" },
          };
        }
      }
    }
  });

  // Define border style
  const borderStyle = {
    top: { style: "hair" },
    left: { style: "thin" },
    bottom: { style: "hair" },
    right: { style: "thin" },
  };
  const borderStyleThin = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  //--> Set body style
  var maxRow = startRow + excelData.length;
  for (let row = startRow; row < maxRow; row++) {
    for (let col = 1; col <= 12; col++) {
      // Columns A (1) to L (12)
      const cell = ws.getCell(row, col);
      // Get value for set bold by check seq
      let isBold = false;
      if (col === 1) {
        const val = cell.value;
        if (val !== null && !val.toString().includes(".")) {
          isBold = true;
        }
      } else if (col === 2) {
        const val = ws.getCell(row, col - 1);
        if (val !== null && !val.toString().includes(".")) {
          isBold = true;
        }
      }
      // Border
      cell.border =
        row === maxRow - 1 || row === maxRow - 6
          ? {
              left: borderStyleThin.left,
              bottom: borderStyleThin.bottom,
              right: borderStyleThin.right,
            }
          : {
              top: borderStyle.top,
              left: borderStyle.left,
              bottom: borderStyle.bottom,
              right: borderStyle.right,
            };
      // Alignment
      cell.alignment =
        col === 1 ||
        col === 3 ||
        col === 4 ||
        col === 5 ||
        col === 6 ||
        (col === 2 && cell.value && cell.value.includes("Sub Total Item"))
          ? { vertical: "middle", horizontal: "center" }
          : col === 2 && row < maxRow - sumData.length
            ? { vertical: "middle", horizontal: "left", wrapText: true }
            : { vertical: "middle", horizontal: "right" };

      // Number format
      // cell.numFmt = col >= 7 && col <= 12 ? "#,##0.00" : "";
      cell.numFmt =
        col >= 7 && col <= 12
          ? "#,##0.00;[Red]-;-" // Custom format to show "-" for zero
          : "_-* #,##0.00_-;-* #,##0.00_-;_-* " - "??_-;_-@_-";

      // Font
      cell.font = {
        name: "Arial Narrow",
        family: 4,
        size: 10,
        bold:
          row >= maxRow - sumData.length || ((col === 1 || col === 2) && isBold)
            ? true
            : false,
      };
    }
  }

  // Save the workbook to a Blob
  const buffer = await wb.xlsx.writeBuffer();
  // Create a Blob from the buffer with the correct MIME type for Excel
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const excelName = genBOQFileName(userID);
  // Use FileSaver to save the file
  saveAs(blob, excelName);

  // Upload to Google Cloud Storage
  await uploadToGCS(blob, excelName, userID, uName);

  return excelName;
}

const uploadToGCS = async (file, fileName, uID, uName) => {
  var formData = new FormData();

  if (file) {
    formData.append("file", file);
    formData.append("fname", fileName);
    formData.append("user_id", uID);
    formData.append("uname", uName);
  }

  await uploadBOQ(formData).then((res) => {
    if (res && res.status === 200 && res.data.success === true) {
      // console.log("File uploaded successfully");
    } else if (res.status === 401) {
      signOut();
    } else {
      console.log(`Error uploadBOQ:`, res);
      console.error("File upload failed");
    }
  });
};

// Generate exported file name as YYYYMMDDhhmmss
const genBOQFileName = (userID) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}${userID}-BOQ.xlsx`;
};

const getLogo = (logo) => {
  switch (logo) {
    case "industrial":
      return LogoIndustrial;
    case "group":
      return LogoGroup;
    case "logistic":
      return LogoLogistics;
    case "utility":
      return LogoUtility;
    default:
      return null;
  }
};
